module.exports = __webpack_public_path__ + "static/osao-480x480-79665a2f59a34d5804b21d5c62842488.png";